import { jsxs, jsx } from "react/jsx-runtime";
const IconResumeSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M17 2H7C5.346 2 4 3.346 4 5v14c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3Zm1 17a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14Z" }),
      /* @__PURE__ */ jsx("circle", { cx: 12, cy: 10, r: 2 }),
      /* @__PURE__ */ jsx("path", { d: "M13 13h-2a2 2 0 0 0-2 2v1h6v-1a2 2 0 0 0-2-2Z" })
    ]
  }
);
export {
  IconResumeSvg
};
